<template>
  <div class="tile is-child is-warning notification" v-on:click="onClickPG">
    <p class="title">
      From ${{minPrice}}
    </p>
    <div class="content">
      <icon-segments :permutation=this.permutation></icon-segments>
    </div>
  </div>
</template>

<script>
  import IconSegments from './IconSegments';
  export default {
    name: 'PermutationGroup',
    props: ['permutation', 'minPrice'],
    components: {
      IconSegments,
      'icon-segments': IconSegments
    },
    data() {
      return {};
    },
    methods: {
      onClickPG() {
        this.$emit('click-pg', this.permutation);
      }
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/PermutationGroup.vue